document.addEventListener("submit", async function (e) {
  const submitter = e.submitter;

  if (
    submitter &&
    submitter.type === "submit" &&
    submitter.name === "add"
  ) {
    e.preventDefault();

    const variantId = 61081414992202;

    // Hat der Kunde die Versicherung im Warenkorb ausgeschaltet (Schalter im Cart Drawer, gilt fuer den Besuch),
    // bleibt sie draussen, bis er sie selbst wieder einschaltet (seit 21.10.2026)
    let optedOut = false;
    try { optedOut = sessionStorage.getItem('nw_insurance_optout') === '1'; } catch (err) {}

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const itemExists = cart.items.some(
        item => item.variant_id === variantId
      );

      if (!itemExists && !optedOut) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });
      }

      fetch('/?sections=header,cart-drawer')
        .then((res) => res.json())
        .then((data) => {
          // ----- Update Cart Bubble -----
          const headerHTML = data?.sections?.header || data.header;
          if (headerHTML) {
            const parser = new DOMParser();
            const headerDoc = parser.parseFromString(headerHTML, 'text/html');
            const newBubble = headerDoc.querySelector('.cart-count-bubble');
            const currentBubble = document.querySelector('.cart-count-bubble');

            if (newBubble && currentBubble) {
              currentBubble.replaceWith(newBubble);
            }
          } else {
            console.warn('Header section not found in JSON:', data);
          }

          // ----- Update Cart Drawer -----
          const drawerHTML = data?.sections?.['cart-drawer'] || data['cart-drawer'];
          if (drawerHTML) {
            const parser = new DOMParser();
            const drawerDoc = parser.parseFromString(drawerHTML, 'text/html');
            const newDrawer = drawerDoc.querySelector('#CartDrawer .totals');
            const currentDrawer = document.querySelector('#CartDrawer .totals');
            if (!optedOut) document.querySelector(".custship-cart-toggle").classList.add("toggleproductactive");

            if (newDrawer && currentDrawer) {
              currentDrawer.replaceWith(newDrawer);
            }
          } else {
            console.warn('Cart drawer section not found in JSON:', data);
          }
        })
        .catch((err) => console.error('Cart UI update error:', err));

    } catch (error) {
      console.error("Error:", error);
    }
  }
});